<template>
  <div>
    <h2>{{title}}</h2>
    <h4>Report Control</h4>
    <hr />
    <h5>Ask parameters here</h5>
    <pre>
      <!-- <report-parameters></report-parameters> -->
      - Parameters are controled by the report config
      - which means we only know at runtime what parameters will be asked
      - but, whatever we  ask for, we just include when we ask for the report data
      - it will be up to the config to ensure all the right query params or body params are included

      - The format of the report is controlled by the config
      - the fields included in the report are controlled by the config
      - subtotals are controlled by the config (if any) <-- this part is rather straight forward so we may want to chat about this part
      - totals are controlled by the config
      - field formatting is controlled by the config

      I would recommend we start very simple 

      A good way to think about the goal is how quickbooks (or other accounting software) asks for reports.  The fields they ask for
      depends on the report you want.  The format of the report depends on the report you want.  The subtotals and totals depend on the report you want.

      This will likey be 2 separate controlls - one for the report parameters and one to render report.  

    </pre>
    <h5>Render report gere</h5>
    <!-- <report-render></report-render> -->
    <pre style="white-space: pre;">
      heading

      body
      body

      subtotal

      body
      body

      subtotal

      body
      body

      subtotal

      total

    </pre>
  </div>
</template>

<script>
// @ is an alias to /src
import Moment from "moment"

export default {
  name: 'ReportControl',
  components: {
  },
  props: {
    title: { type: String, default: "Report" },
    data: {type: Object,default: () => {}},
    userOptions: {type: Object,default: () => {}},
    // likely more stuff here...
  },
  data() {
    return {
     
    }
  },
  mounted() {
    console.log("reportControl mounted ");
  },
  computed: {
  },
  methods: {
    done() {
      this.$emit( 'done' );
    },
    printReport() {
      window.print();   // this may take some formatting and might be a better choice to format as PDF
    }
  }
}
</script>
<style lang="scss" scoped>
 
  @media print {
   
    @page {
      margin:0px !important;
      padding: 0px;
      
    }

    .noprint, #nav {
      display: none;
    }
  }

  /* style sheet for "letter" printing */
  @page {
    size: A4;
    margin: 0;
  }
</style>